import React from 'react';


const Skill = props => (
  <img
    alt={props.name}
    src={props.src}
    loading={"lazy"}
    className={"resize-img"}
    width={300}
    height={100}
  />
);

export default Skill;
